export const NAME = 'schemaForm';
export const SOURCE_TYPE = 'schema-form-sortable/source-item';
export const ITEM_TYPE = 'schema-form-sortable/item';
export const PLACEHOLDER_KEY = 666;
